import * as $ from 'jquery/dist/jquery.js';
import 'jquery-validation/dist/jquery.validate.js'
import Inputmask from 'inputmask/dist/inputmask/jquery.inputmask.js';

$(document).ready(function(){
  
  $('.ic-input').inputmask("999999-99-9999");
  $('.hp-contact').inputmask("9999-9{7,8}");

  $.validator.addMethod("valid_ic", function(value, element) {
    return this.optional(element) || $(element).inputmask("isComplete");
  }, "Please enter a valid IC in the format 123456-78-9012");

  $.validator.addMethod("valid_contact_mobile", function(value, element) {
    return this.optional(element) || $(element).inputmask("isComplete");
  }, "Please enter a valid contact in the format 6012-3457890");

  $('.client-sign-up-form').validate({
    errorElement: "span",
    errorClass: "badge badge-danger form-error-msg mt-2",
    rules:{
      "client[login]": {
        required: true,
        valid_ic: true
      },
      "client[name]": {
        required: true
      },
      "client[password]": {
        required: true
      },
      "client[password_confirmation]": {
        required: true,
        equalTo: "#client_password"
      },
      "client[contact_mobile]": {
        required: true,
        valid_contact_mobile: true
      },
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass('border');
      $(element).addClass('border-danger');
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).removeClass('border');
      $(element).removeClass('border-danger');
    },
    errorPlacement: function(error, element) {
      error.appendTo(element.parent(".form-group"));
    },
    messages: {
      "client[login]": {
        required: "Identity Card is required."
      },
      "client[name]": {
        required: "Name is required."
      },
      "client[password]": {
        required: "Password is required."
      },
      "client[password_confirmation]": {
        required: "Password confirmation is required.",
        equalTo: "Confirmation password not matched with password"
      },
      "client[contact_mobile]": {
        required: "Contact mobile is required.",
        valid_contact_mobile: "Valid contact mobile is required."
      }
    }
  });







});

